import { houseSearchType, WEB_BASE_URL } from './config'
import { fetchGet, fetchPost } from './fetch/server'

export function parseURLSearchParams(str) {
  const params = {}
  if (!str) return params

  const searchParams = str?.entries ? str : new URLSearchParams(str)
  /* eslint-disable no-restricted-syntax */
  for (const [key, value] of searchParams.entries()) {
    params[key] = value
  }

  return params
}

function search(type, pathname) {
  const slug = pathname || 'list_page-1'
  return `${WEB_BASE_URL}/search/${type}/${slug}`
}

function getConfigs() {
  const tmp = [
    // 处理 链接中存在 zh-TW 页面报404的问题
    {
      pattern: /\/(zh-TW)\/([\w\W]+)/,
      callback: (r) => [String(r[1]).toLowerCase(), r[2]].join('/')
    },
    // 从房源搜索列表过来的
    // https://nz.hougarden.com/house-search/type_listing_page_1
    {
      pattern: /^\/house-search\/type_([^_]+)_?([\w\W]+)/,
      callback([, type]) {
        if(type === 'agents') {
          return `${WEB_BASE_URL}/find-an-agent`
        }
  
        const typeMaps = {
          listing: 'residential',
          'new-homes': 'newHomes',
          'commercial-for-sale': 'commercialForSale',
          'commercial-for-lease': 'commercialForLease',
        }
  
        const realType = houseSearchType[type] 
          || houseSearchType[typeMaps[type]]
          || houseSearchType.residential
  
        return search(realType)
      }
    },
    // 匹配直接在url后添加房源id
    {
      pattern: /^\/([\d]+)$/,
      async callback(_matchs, _obj, url) {
        const d = await fetchPost('old-url-301', { url })
        
        if(!d?.slug || d?.slug === '/') {
          return ''
        }
  
        return `${WEB_BASE_URL}/property/${d.slug}`
      }
    },
    // 匹配房源详情，估价详情
    {
      pattern: /^(?:\/estimate)?\/([^_\\/]+?)-([\d]+)$/,
      async callback(_matchs, _obj, url) {
        const d = await fetchPost('old-url-301', { url })
  
        if(!d?.slug || d?.slug === '/') {
          return ''
        }
  
        return `${WEB_BASE_URL}/property/${d.slug}`
      }
    },
    // 买房首页
    {
      pattern: /^\/house-for-sale$/,
      callback() {
        return search(houseSearchType.residential)
      }
    },
    // 租房首页
    {
      pattern: /^\/house-for-rent|flatmates$/,
      callback() {
        return search(houseSearchType.rent)
      }
    },
    // 估价首页
    {
      pattern: /^\/estimate$/,
      callback() {
        return search(houseSearchType.estimate)
      }
    },
    // 个人中心
    {
      pattern: /^\/profile$/,
      callback() {
        return `${WEB_BASE_URL}/u/profile`
      }
    },
    // 匹配 https://7thave.atlassian.net/browse/HT-622中提到的url
    // eg: http://localhost:3100/search/houses-for-sale
    // 
    {
      pattern: /^\/search\/([^/]+)\/?$/,
      callback(matchs) {
        return matchs?.[1]
          ? search(matchs?.[1])
          : null
      }
    },
    {
      pattern: /^\/suburbs\/?$/,
      callback() {
        return `${WEB_BASE_URL}/suburbs/page-1`
      }
    },
    {
      pattern: /^\/list-redirect\/?$/,
      async callback(_matchs, urlObj) {
        const query = parseURLSearchParams(urlObj.search)
        const d = await fetchGet('list-redirect', query)

        if(!d?.slug || d?.slug === '/') {
          return ''
        }
  
        return `${WEB_BASE_URL}/property/${d.slug}`
      }
    },
  ]

  return tmp
}

const configs = getConfigs()

function getCallback(urlObject) {
  if(!urlObject) {
    return {}
  }

  let fn
  let matchs
  const { pathname } = urlObject
  
  for(let i = 0, len = configs.length; i < len; i++) {
    const { pattern, callback } = configs[i]
    matchs = pathname.match(pattern)

    if(matchs) {
      fn = callback
      break
    }
  }

  return { fn, matchs }
}

export default async function getNewUrl(url) {
  let newUrl
  try{ 
    const urlObj = new URL(url)
    const { fn, matchs } = getCallback(urlObj)
    
    if(fn) {
      newUrl = await fn(matchs, urlObj, url)
    }
  } catch(err) {
    // 
  }

  return newUrl
}
